import api, { AREAS_URL } from "./api";

export const fetchCityArea = async (areaId) => {
  return await api.get(`${AREAS_URL}/${areaId}/subAreas
  `);
};
